import React from 'react';
import TipaltiProfileTab from './TipaltiProfileTab';

export default class TipaltiProfileWindowDescription {
  static getTitle() {
    return `Tipalti ID (GUID): ${TipaltiProfileWindowDescription.getTipaltiId()}`;
  }

  static getTipaltiId() {
    return TipaltiProfileWindowDescription.getFilterParameters()?.TipaltiId;
  }

  static getTabs() {
    return [
      {
        label: 'Tipalti Profile',
        id: 'tipalti_profile_tab',
        icon: 'fas fa-user',
        component: <TipaltiProfileTab tipaltiId={TipaltiProfileWindowDescription.getTipaltiId()} />,
      },
    ];
  }

  static getFilterParameters() {
    return null;
  }
}
